export const EXCLUDED_PAGES: string[] = [
  "/diary-greeting",
  "/questions-greeting",
  "/secret-word",
];
